<script setup lang="ts">
import SelectionMenu from "../SelectionMenu/SelectionMenu.vue";
import TypedInputPanel from "@/components/canvas/Tools/TypedInputPanel.vue";
import PartAssignBar from "@/components/canvas/analysis/PartAssignBar.vue";
import { Z_INDEX_SELECTION } from "./constants";
import { isCanvasDrawing } from "@/stores/CanvasViewState";
import { usePlanAnalysisState } from "@/stores/PlanAnalysisState";
import { isSelectionSheet } from "@/stores/CanvasLayoutState";

defineProps<{
  fullscreen: boolean;
}>();

// Mode association (une partie sélectionnée dans l'onglet Parties du volet
// Observations) : sa barre prend la place de la barre de sélection.
const analysis = usePlanAnalysisState();
</script>

<template>
  <!--
  Colle au bord bas du canvas : la barre de selection en sort (cf. son
  animation), elle n'y flotte pas. Le panneau de l'outil texte, lui, vit dans
  la barre d'outils (TextDraggerMenu).

  Z_INDEX_SELECTION la place au-dessus de tout le reste, aide contextuelle
  comprise : elle partage le bandeau bas avec elle et c'est elle qui prime.
  -->
  <!-- Écran étroit : toute la largeur disponible, la barre de sélection passe
       ses outils à la ligne. -->
  <div
    class="position-absolute d-flex no-capture canvas-icon-scaled"
    :class="isSelectionSheet ? 'start-0 end-0' : 'start-50 translate-middle-x'"
    :style="{
      bottom: 0,
      zIndex: Z_INDEX_SELECTION,
    }"
  >
    <div
      class="d-flex flex-column align-items-center justify-content-end gap-2 flex-grow-1"
    >
      <TypedInputPanel class="capture" />
      <PartAssignBar
        v-if="analysis.assignPartId !== null && analysis.assignDiagnosticId"
        class="capture"
        :diagnostic-id="analysis.assignDiagnosticId"
      />
      <SelectionMenu
        v-else
        class="capture"
        :class="{
          'drawing-active': isCanvasDrawing,
        }"
        :sheet="isSelectionSheet"
      />
    </div>
  </div>
</template>

<style lang="scss" scoped></style>
